export enum OfferStatus {
  sent = "SENT",
  unsent = "UNSENT",
  accepted = "ACCEPTED",
  countered = "COUNTERED",
  canceled = "CANCELED",
}
